'use client'

import { useState, useContext } from 'react'
import { Button } from '@/components/ui/shadcn/button'
import { Separator } from '@/components/ui/shadcn/separator'
import { AuthContext } from '@/contexts/AuthContext'
import ConfirmAccount from '@/app/manager/settings/components/ConfirmAccount'
import ConfirmOrganization from '@/app/manager/settings/components/ConfirmOrganization'
import OrganizationModal from '@/components/common/modals/OrganizationModal'

export default function Danger() {
  const [accOpen, setAccOpen] = useState(false)
  const [orgOpen, setOrgOpen] = useState(false)
  const [openChooseOrg, setOpenChooseOrg] = useState(false)
  const [orgModalPage, setOrgModalPage] = useState('choose')
  const authContext = useContext(AuthContext)

  return (
    <div className="rounded-lg border bg-card p-4">
      <ConfirmAccount open={accOpen} setOpen={setAccOpen} />
      <ConfirmOrganization
        open={orgOpen}
        setOpen={setOrgOpen}
        onDelete={() => setOpenChooseOrg(true)}
      />
      <OrganizationModal
        open={openChooseOrg}
        setOpen={setOpenChooseOrg}
        page={orgModalPage}
        setPage={setOrgModalPage}
        startPage="choose"
      />
      <div className="grid gap-4">
        <h3 className="text-lg font-semibold">Danger Zone</h3>
        <div className="grid grid-cols-12 gap-4 items-center">
          <div className="col-span-10">
            <p className="font-medium">Delete Organization</p>
            <p className="text-sm text-muted-foreground">
              Permanently delete this organization and all of its data.
            </p>
          </div>
          <div className="col-span-2">
            <Button
              onClick={() => setOrgOpen(true)}
              variant="destructive"
              disabled={
                authContext.user.id !== authContext.user.organization.owner
              }
              className="w-full"
            >
              Delete Organization
            </Button>
          </div>
        </div>
        <Separator />
        <div className="grid grid-cols-12 gap-4 items-center">
          <div className="col-span-10">
            <p className="font-medium">Delete my Account</p>
            <p className="text-sm text-muted-foreground">
              Permanently delete your account and remove your access from all
              organizations.
            </p>
          </div>
          <div className="col-span-2">
            <Button
              onClick={() => setAccOpen(true)}
              variant="destructive"
              className="w-full"
            >
              Delete Account
            </Button>
          </div>
        </div>
      </div>
    </div>
  )
}
